export default __webpack_public_path__ + "static/media/P940_B_BD.bf519575.pdf";